import { useLocation } from 'react-router-dom'

const useSearchParam = (name: string) => {
  const properties = new URLSearchParams(useLocation().search)
  return properties.get(name)
}

export default useSearchParam
